module.exports = __webpack_public_path__ + "static/media/north-europe.8235032c.jpg";